import { createEventEmitter } from '../event'

export const checklistEventEmitter = createEventEmitter()
